import styled from "styled-components"
import {
  maxWidth,
  width,
  space,
  flexDirection,
  alignItems,
  justifyContent,
  flex,
  color,
  flexWrap,
  borderRadius,
  borderWidth,
  borderColor,
  style
} from "styled-system"

const Box = styled.div`
display: flex;
box-shadow:${props => props.boxShadow};
${maxWidth};
${width};
${space};
${flexDirection};
${justifyContent};
${alignItems};
${flex};
${color};
${flexWrap};
${borderRadius};
${borderWidth};
${borderColor};
${style};
`

export default Box


// WEBPACK FOOTER //
// ./src/lib/ui/ui-box/ui-box.component.js